import ekozAxios from './instance/axios';

export const updateUser = ({
  userId,
  firstName,
  lastName,
  email,
  description,
  personalBio,
  organizationId,
  showNotes,
  roleId,
}) => ekozAxios.request({
  method: 'post',
  url: '/users/edit_user.php',
  data: {
    id: userId,
    fname: firstName,
    lname: lastName,
    email,
    description,
    personal_bio: personalBio,
    organization_id: organizationId,
    show_notes: showNotes,
    role_id: roleId,
  },
});

export const readUsers = ({
  userId,
  organizationId,
} = {}) => ekozAxios.request({
  method: 'get',
  url: '/users/get_users.php',
  params: {
    id: userId,
    organization_id: organizationId,
  },
}).then((res) => res.map((item) => ({
  ...item,
  id: Number(item.id),
})));

export const deleteUser = (userId) => ekozAxios.request({
  method: 'post',
  url: '/users/delete_user.php',
  data: {
    id: userId,
  },
});

export const inviteUser = ({
  organizationId,
  firstName,
  lastName,
  email,
  roleId,
}) => ekozAxios.request({
  method: 'post',
  url: '/users/invite_user.php',
  data: {
    organization_id: organizationId,
    first_name: firstName,
    last_name: lastName,
    email,
    role_id: roleId,
  },
});

export const createUser = ({
  email,
  password,
  firstName,
  lastName,
  roleId,
  description,
  personalBio,
  showNotes,
  organizationId,
}) => ekozAxios.request({
  method: 'post',
  url: '/users/new_user.php',
  data: {
    email,
    password,
    fname: firstName,
    lname: lastName,
    role_id: roleId,
    description,
    personal_bio: personalBio,
    show_notes: showNotes,
    organization_id: organizationId,
  },
});

export const requestPasswordReset = ({
  email,
}) => ekozAxios.request({
  method: 'post',
  url: '/users/request_password_reset.php',
  data: {
    email,
  },
});

export const resetPassword = ({
  token,
  password,
}) => ekozAxios.request({
  method: 'post',
  url: '/users/reset_password.php',
  data: {
    token,
    password,
  },
});
